import type { NestTestResult } from "./history";

export enum TestStatus {
  PASS = "PASS",
  FAIL = "FAIL",
  NO_DATA = "NO_DATA",
}

export enum ValidationSeverity {
  ERROR = "ERROR",
  WARNING = "WARNING",
  INFO = "INFO",
}

export interface LocalizedText {
  key: string;
  parameters?: Record<string, unknown>;
}

export interface Error {
  code: string;
  message: LocalizedText;
  requestId?: string;
}

export interface LastRun {
  id: string;
  status: TestStatus;
}

export interface NestDocumentTypes {
  id: string;
  name: LocalizedText;
  documentation: LocalizedText;
}

export enum NestStyle {
  RED = "RED",
  YELLOW = "YELLOW",
  ORANGE = "ORANGE",
  BLUE = "BLUE",
}

export interface NestUseCaseDocumentationCommonErrorsTag {
  style: NestStyle;
  name: LocalizedText;
}
export interface NestUseCaseDocumentationCommonErrors {
  content: LocalizedText;
  style: NestStyle;
  tags: NestUseCaseDocumentationCommonErrorsTag[];
}

export interface NestUseCaseDocumentation {
  content: LocalizedText;
  commonErrors: NestUseCaseDocumentationCommonErrors[];
}

export interface NestUseCase {
  id: string;
  countryCode: string;
  name: LocalizedText;
  lastRun: LastRun;
  documentation: NestUseCaseDocumentation;
  documentTypes: NestDocumentTypes[];
  partnerTypes?: string[];
}

export enum UploadStatus {
  PENDING = "pending",
  UPLOADING = "uploading",
  DONE = "done",
  ERROR = "error",
}

export interface UploadProgress {
  fileName: string;
  progress: number;
  status: UploadStatus;
  error?: Error;
  file: File;
  statusCode?: number;
  testResult?: NestTestResult;
}
